/// <reference types="@types/googlemaps" /> // Don't remove this line!!! It isn't normal comment!
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { StockApiService } from '../../../services/stock-api.service';
import { BasicFilter } from '../../../models/search/basic-filter';
import { AdvancedFilter } from '../../../models/search/advanced-filter';
import { Result } from '../../../models/search/result';
import { ActivatedRoute } from '@angular/router';
import { QueryStringService } from '../../../services/query-string.service';
import { AppComponent } from '../../../app.component';
import { LocalStorageService } from '../../../services/local-storage.service';
import { AdobeService } from '../../../services/adobe.service';
import { ErrorHandler } from '../../../tools/error-handler';
import { BlueKaiService } from '../../../services/blue-kai.service';
import { TitleService } from '../../../services/title.service';
import { LabelProviderService } from '../../../services/labelProvider.service';
import { TawkToChatService } from '../../../services/tawk-to-chat.service';
var ListComponent = /** @class */ (function () {
    function ListComponent(stockApiService, route, QSS, LSS, adobeService, blueKaiService, titleService, labelProviderService) {
        var _this = this;
        this.stockApiService = stockApiService;
        this.route = route;
        this.QSS = QSS;
        this.LSS = LSS;
        this.adobeService = adobeService;
        this.blueKaiService = blueKaiService;
        this.titleService = titleService;
        this.labelProviderService = labelProviderService;
        this.basicFilters = new BasicFilter();
        this.advancedFilters = new AdvancedFilter();
        this.result = new Result();
        this.resultListLoading = true;
        this.page = 1;
        this.sort = 'popular';
        this.dealerCode = null;
        this.openedFilters = false;
        this.pageLoadTime = null;
        this.bk_lastModel = undefined;
        this.newCarsOfferCount = null;
        this.initOfferCount = 'init';
        this.goToHomepageSubscription = null;
        this.sort = QSS.getParam('sort') === null ? this.sort : QSS.getParam('sort');
        this.page = QSS.getParam('page') === null ? this.page : +QSS.getParam('page');
        this.idParamSubscription = this.route.params.subscribe(function (params) {
            if (params['dealer_code']) {
                _this.dealerCode = params['dealer_code'];
            }
            if (params['page']) {
                _this.page = params['page'];
            }
            if (params['sort']) {
                _this.sort = params['sort'];
            }
        });
        stockApiService.getBasicSearchData().then(function (value) {
            _this.basicFilters = value;
        }).catch(function (reason) {
            ErrorHandler.handle(reason);
        });
        stockApiService.getNewCarsInfo().then(function (value) {
            _this.newCarsOfferCount = value.currentBrand.offerCount;
        }).catch(function (reason) {
            ErrorHandler.handle(reason);
        });
    }
    ListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.adobeService.pageLoadHomepage(this.QSS.getParam('models'), this.QSS.getParam('cid'));
        this.pageLoadTime = new Date().getTime();
        setTimeout(function () {
            AppComponent.bodyClass = 'page page-offerts-list';
            TawkToChatService.enableTawkToChat(AppComponent.dealerCode, false);
        });
        this.idParamSubscription.unsubscribe();
        if (this.goToHomepageSubscription !== null) {
            this.goToHomepageSubscription.unsubscribe();
        }
        this.goToHomepageSubscription = AppComponent.goToHomepage.subscribe(function () {
            setTimeout(function () {
                _this.pageLoadTime = new Date().getTime();
                _this.onFilterUpdate(true);
                _this.adobeService.pageLoadHomepage(_this.QSS.getParam('models'), _this.QSS.getParam('cid'));
            }, 100);
        });
    };
    ListComponent.prototype.onFilterUpdate = function (notSendTrackingData) {
        if (notSendTrackingData === void 0) { notSendTrackingData = false; }
        this.LSS.set('lfprop', this.QSS.getAllParams());
        this.beforeFilterUpdate();
        var filters = this.getFilters();
        var page = this.page;
        var sort = this.sort;
        if (this.QSS.getParam('place_id') !== null && this.QSS.getParam('max_distance') !== null) {
            this.joinCoordinatesAndGetSearchData(filters, page, sort, notSendTrackingData);
        }
        else {
            this.getSearchData(filters, page, sort, notSendTrackingData);
        }
    };
    ListComponent.prototype.getSearchData = function (filters, page, sort, notSendTrackingData) {
        var _this = this;
        this.stockApiService.getSearchData({ filters: filters, page: page, sort: sort }).then(function (value) {
            _this.advancedFilters = value.advancedFilters;
            _this.result = value.result;
            _this.resultListLoading = false;
            _this.result.list = _this.labelProviderService.fillOfferLabelsByArray(_this.result.list);
            if (_this.initOfferCount === 'init') {
                _this.initOfferCount = value.result.list.length;
            }
            else if (_this.initOfferCount === 0 && value.result.list.length > 0) {
                _this.initOfferCount = value.result.list.length;
            }
            var adobeFilters = 'model:' + (filters.model || '') + '|' +
                'fuel:' + (filters.fuelType || '') + '|' +
                'priceF:' + (filters.priceFrom || '') + '|' +
                'priceT:' + (filters.priceTo || '') + '|' +
                'location:' + (filters.longitude ? $('input[name="location"]').val() : '') + '|' +
                'year:' + (_this.QSS.getParam('production_year') || '') + '|' +
                'gear:' + (_this.QSS.getParam('gearboxType') || '') + '|' +
                'drive:' + (_this.QSS.getParam('driveType') || '') + '|' +
                'power-engine:' + (_this.QSS.getParam('enginePower_from') || '') + '-' + (_this.QSS.getParam('enginePower_to') || '') + '|' +
                'color:' + (_this.QSS.getParam('color') || '') + '|' +
                'interior:' + (_this.QSS.getParam('interior_type') || '') + '|' +
                'optional:' + (_this.QSS.getParam('equipment') || '') + '|' +
                'km:' + (_this.QSS.getParam('mileage') || '');
            if (!notSendTrackingData && ((new Date().getTime() - _this.pageLoadTime) > 1500)) {
                _this.adobeService.loadedSearchResults(adobeFilters, value.result.info.countOfResults);
            }
            if ((filters.model || null) !== _this.bk_lastModel) {
                var dealer = null;
                if (filters.dealer && /^\d{7}$/.test(filters.dealer)) {
                    if (_this.result.info.dealerNames && Object.keys(_this.result.info.dealerNames).length > 0) {
                        dealer = _this.result.info.dealerNames[Object.keys(_this.result.info.dealerNames)[0]];
                    }
                }
                _this.blueKaiService.changeRoute(filters.model, dealer);
                _this.bk_lastModel = filters.model;
            }
            var dealerName = null;
            if (filters.dealer && /^\d{7}$/.test(filters.dealer)) {
                if (_this.result.info.dealerNames && Object.keys(_this.result.info.dealerNames).length > 0) {
                    dealerName = _this.result.info.dealerNames[Object.keys(_this.result.info.dealerNames)[0]];
                }
            }
            _this.titleService.setTitleList(filters.model, dealerName);
        }).catch(function (reason) {
            ErrorHandler.handle(reason);
        });
    };
    ListComponent.prototype.joinCoordinatesAndGetSearchData = function (filters, page, sort, notSendTrackingData) {
        return __awaiter(this, void 0, void 0, function () {
            var geocoder;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        geocoder = new google.maps.Geocoder();
                        return [4 /*yield*/, geocoder.geocode({ placeId: this.QSS.getParam('place_id') }, function (results) {
                                filters.lat = results[0].geometry.location.lat();
                                filters.lng = results[0].geometry.location.lng();
                                _this.getSearchData(filters, page, sort, notSendTrackingData);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ListComponent.prototype.getFilters = function () {
        var productionYear = this.QSS.getParam('production_year');
        if (productionYear !== null) {
            productionYear = productionYear.toString().split(':;');
        }
        var gearboxType = this.QSS.getParam('gearboxType');
        if (gearboxType !== null) {
            gearboxType = gearboxType.toString().split(':;');
        }
        var driveType = this.QSS.getParam('driveType');
        if (driveType !== null) {
            driveType = driveType.toString().split(':;');
        }
        var color = this.QSS.getParam('color');
        if (color !== null) {
            color = color.toString().split(':;');
        }
        var interiorType = this.QSS.getParam('interior_type');
        if (interiorType !== null) {
            interiorType = interiorType.toString().split(':;');
        }
        var equipment = this.QSS.getParam('equipment');
        if (equipment !== null) {
            equipment = equipment.toString().split(':;');
        }
        var label = this.QSS.getParam('label');
        if (label !== null) {
            label = label.toString().split(':;');
        }
        var financialProductsUrl = this.QSS.getParam('promoFinancialProductsOnly');
        var financialProducts = false;
        if (financialProductsUrl !== null) {
            financialProductsUrl = financialProductsUrl.toString();
            if (financialProductsUrl === 'true') {
                financialProducts = true;
            }
        }
        return {
            dealer: this.dealerCode,
            model: this.QSS.getParam('models'),
            version: this.QSS.getParam('version'),
            maxLength: this.QSS.getParam('maxLength'),
            maxHeight: this.QSS.getParam('maxHeight'),
            fuelType: this.QSS.getParam('fuelType'),
            priceFrom: this.QSS.getParam('price_from'),
            priceTo: this.QSS.getParam('price_to'),
            mileage: this.QSS.getParam('mileage'),
            maxDistance: this.QSS.getParam('max_distance'),
            lat: null,
            lng: null,
            productionYear: productionYear,
            gearboxType: gearboxType,
            driveType: driveType,
            enginePowerFrom: this.QSS.getParam('enginePower_from'),
            enginePowerTo: this.QSS.getParam('enginePower_to'),
            color: color,
            interiorType: interiorType,
            equipment: equipment,
            label: label,
            promoFinancialProductsOnly: financialProducts,
        };
    };
    ListComponent.prototype.beforeFilterUpdate = function () {
        this.resultListLoading = true;
    };
    ListComponent.prototype.filtersVisibleEvent = function () {
        this.openedFilters = !this.openedFilters;
    };
    ListComponent.prototype.pageChange = function (val) {
        this.pageChangeOnly(val);
        this.onFilterUpdate(true);
    };
    ListComponent.prototype.pageChangeOnly = function (val) {
        this.page = val;
        this.QSS.setParam('page', val);
    };
    ListComponent.prototype.sortChange = function (val) {
        this.sort = val;
        this.QSS.setParam('sort', val);
        this.page = 1;
        this.QSS.setParam('page', 1);
        this.onFilterUpdate(true);
    };
    return ListComponent;
}());
export { ListComponent };
